const useUserStore = defineStore('user', {
    state: () => ({
        token: '',
        userInfo: {},
    }),
    actions: {
        //新登录
        saveLoginInfo(res) {
            let data = res.data
            this.token = data.access_token
            this.userInfo = data.user_info
            return Promise.resolve()
        },
        // 更新用户信息
        updateUserInfo(data) {
            this.userInfo = {
                ...this.userInfo,
                // 只会更新下列字段：用户名
                name: data.name,
            }
        },
        // 退出系统，token过期自动调用
        logOut() {
            return new Promise((resolve, reject) => {
                this.token = ''
                this.userInfo = {}
                localStorage.clear()
                sessionStorage.clear()
                resolve()
            })
        }
    },
    persist: {
        key: 'user',
        enabled: true,
        storage: localStorage,
    }
})

export default useUserStore
